import { Box, Grid } from "@mui/material";
import { FormikProps } from "formik";
import { EMERGENCY_CONTACT_RELATIONSHIP_WITH_PATIENT } from "../../../../../constants/provider/add-new-patient";
import {
  INITIAL_EM_CONTACT,
  NewPatientForm,
} from "../../../../../constants/provider/patient/add-new-patient/add-new-patient-form";
import CustomSelect from "../../../../CustomSelect";
import Input from "../../../../Input";
import StyledButtonV2 from "../../../StyledButtonV2";
import Flex from "../../../../Flex";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import MaskInput from "../../../../MaskInput";
import CustomTitle from "../../../CustomTitle";
import OutlineCard from "../../../../OutlineCard";

interface EmergencyContactProps {
  formik: FormikProps<NewPatientForm>;
}

const EmergencyContact = ({ formik }: EmergencyContactProps) => {
  const { values, setFieldValue, handleBlur, handleChange } = formik;

  const setSelfContactDetails = (k: string) => {
    setFieldValue(k + "mobile", formik.values.mobileNumber);
    setFieldValue(k + "firstName", formik.values.firstName);
    setFieldValue(k + "lastName", formik.values.lastName);
    setFieldValue(k + "email", formik.values.email);
  };

  return (
    <Box>
      {values.emergencyContacts?.map((emContact, ind) => (
        <Box
          id={"Emergency Contact"}
          key={ind}
          sx={{
            mt: 2,
          }}
        >
          <Flex justifyContent={"space-between"} alignItems={"center"} mb={1}>
            <CustomTitle>
              {values?.emergencyContacts &&
              values?.emergencyContacts?.length > 1
                ? ` ${ind + 1}. `
                : undefined}
              Family Member / Emergency Contact
            </CustomTitle>
            {ind !== 0 && (
              <StyledButtonV2
                onClick={() =>
                  formik.setFieldValue(
                    "emergencyContacts",
                    formik.values?.emergencyContacts?.toSpliced(ind, 1)
                  )
                }
                variant="text"
                color="primary"
                label="Remove"
                sIcon={<HighlightOffOutlinedIcon />}
              />
            )}
          </Flex>
          <OutlineCard>
            <Grid
              container
              spacing={3}
              sx={{
                p: 0.8,
              }}
            >
              <Grid size={3}>
                <CustomSelect
                  disableSortOptions
                  label="Relationship With Patient"
                  value={emContact.relationshipWithPatient}
                  onChange={(value) => {
                    if (value === "SELF")
                      setSelfContactDetails(`emergencyContacts[${ind}].`);

                    setFieldValue(
                      `emergencyContacts[${ind}].relationshipWithPatient`,
                      value
                    );
                  }}
                  // placeholder="Select"
                  options={EMERGENCY_CONTACT_RELATIONSHIP_WITH_PATIENT}
                  // required
                  error={
                    (formik.errors?.emergencyContacts?.[ind] as any)
                      ?.relationshipWithPatient
                  }
                />
              </Grid>

              <Grid size={3}>
                <Input
                  label="First Name"
                  textFieldProps={{
                    disabled: emContact.relationshipWithPatient === "SELF",
                    name: `emergencyContacts[${ind}].firstName`,
                    value: emContact.firstName,
                    onChange: handleChange,
                    onBlur: handleBlur,
                    // placeholder: "Enter First Name",
                  }}
                  // required={true}
                  error={
                    (formik.touched.emergencyContacts as any)?.[ind]
                      ?.firstName &&
                    (formik.errors?.emergencyContacts?.[ind] as any)?.firstName
                  }
                />
              </Grid>

              <Grid size={3}>
                <Input
                  label="Last Name"
                  textFieldProps={{
                    disabled: emContact.relationshipWithPatient === "SELF",
                    name: `emergencyContacts[${ind}].lastName`,
                    value: emContact.lastName,
                    onChange: handleChange,
                    onBlur: handleBlur,
                    // placeholder: "Enter Last Name",
                  }}
                  // required={true}
                  error={
                    (formik.touched.emergencyContacts as any)?.[ind]
                      ?.lastName &&
                    (formik.errors?.emergencyContacts?.[ind] as any)?.lastName
                  }
                />
              </Grid>
              <Grid size={3}>
                <MaskInput
                  disabled={emContact.relationshipWithPatient === "SELF"}
                  mask={"(999) 999-9999"}
                  label="Mobile Number"
                  // placeholder="Enter Number"
                  value={emContact.mobile}
                  onChange={(e) =>
                    setFieldValue(
                      `emergencyContacts[${ind}].mobile`,
                      e.target.value
                    )
                  }
                />
              </Grid>
              <Grid size={3}>
                <Input
                  label="Email"
                  textFieldProps={{
                    disabled: emContact.relationshipWithPatient === "SELF",
                    name: `emergencyContacts[${ind}].email`,
                    value: emContact.email,
                    onChange: handleChange,
                    onBlur: handleBlur,
                    // placeholder: "Enter Email",
                  }}
                  // required={true}
                  error={
                    (formik.touched.emergencyContacts as any)?.[ind]?.email &&
                    (formik.errors?.emergencyContacts?.[ind] as any)?.email
                  }
                />
              </Grid>
            </Grid>
          </OutlineCard>
        </Box>
      ))}
      <StyledButtonV2
        onClick={() => {
          setFieldValue("emergencyContacts", [
            ...(formik.values.emergencyContacts ?? []),
            ...INITIAL_EM_CONTACT,
          ]);
        }}
        sx={{ marginTop: "10px" }}
        variant="text"
        shouldAddIcon
        label="Add Emergency Contact"
      />
    </Box>
  );
};

export default EmergencyContact;
